
import "@/assets/css/sberpay-btn.css"
import {defineComponent} from 'vue'


export default defineComponent({
  emits: ['btn:click']
})
